import React, { useState } from 'react'


import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { postCompanyFields } from '../../../../MyApi/sb/companyfields'

import AddCompanyFields from '../../../../Components/sb/companyFildes/companyFieldsStore/AddCompanyFields'
import PageHeader from '../../../../Components/UI/PageHeader'

const CompanyFieldsStore = () => {
const [companyFiledName ,setCompanyFieldName]= useState("")


 const mutation = useMutation("postCompanyFields" , (postData)=>postCompanyFields(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setCompanyFieldName("")
    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name:companyFiledName,     
    })
 }
 const isDisabled= ()=>{
     return !(companyFiledName)

 }
  return ( 

    <div>
        <PageHeader title="Add Company Field" showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddCompanyFields setCompanyFieldName={setCompanyFieldName} companyFiledName={companyFiledName} />
    </div>
  )
}

export default CompanyFieldsStore